import EditHolidayGeneralForm from './EditHolidayGeneralForm';
export default EditHolidayGeneralForm;
